import { IonButton, IonModal } from "@ionic/react";
import React, { useEffect, useState } from "react";
import { PickList } from "primereact/picklist";
import "./CustomColumn.scss";
import { utilService } from "../../../../../../services";
import { statusBoardService } from "../../../../StatusBoard.service";
import * as _ from "lodash";
import EditCustomColumn from "../EditCustomColumnPopup/EditCustomColumnPopup";
import { useToast } from "@agney/ir-toast";
import { CONSTANTS } from "../../../../../../constants";
import { statusBoardSocketService } from "../../../../StatusBoardSocketService";
import { rolePermissionsService } from "../../../../../../services/rolePermissions.service";
import { useTranslation } from "react-i18next";

interface ContainerProps {
  showModal: boolean;
  statusBoardData: any;
  updateTableData: (status: boolean) => void;
}
const CustomColumn: React.FC<ContainerProps> = (props) => {
  const { t } = useTranslation("statusBoard");
  const [additionalColumnList, setAdditionalColumnList] = useState([]);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [initialSelectedColumns, setInitialSelectedColumns] = useState([]);
  const [initialAvailableColumns, setInitialAvailableColumns] = useState([]);
  const [availableColumns, setAvailableColumns] = useState([]);
  const [showNewColumnPopup, setNewColumnPopup] = useState(false);
  const rolePermissionData = rolePermissionsService.getRolePermissionsDetails();
  const Toast = useToast();
  useEffect(() => {
    getAllColumns();
  }, []);
  const params = {
    statusBoardId: props.statusBoardData.StatusBoardId,
    reg_code: utilService.getNetwork(),
  };
  const getAllColumns = async () => {
    const respResult: any = await statusBoardService.getAllColumnList(params);
    if (respResult.isSuccess) {
      if (respResult.columnList.length) {
        setColumData(respResult);
      }
    } else {
    }
  };

  const setColumData = (result: any) => {
    let additionalColumnList: any = [];
    let selectedColumns: any = [];
    let availableColumns: any = [];
    let initialSelectedColumns: any = [];
    let initialAvailableColumns: any = [];
  
    additionalColumnList = result.columnList[0].data || [];
    setAdditionalColumnList(additionalColumnList);
  
    const selOrderIds = result.columnList[0].selectedColOrderIDs || [];
  
    if (selOrderIds.length) {
      // find all selected columns
      selectedColumns = selOrderIds
        .map((id: any) => _.find(additionalColumnList, { id }))
        .filter(Boolean);
  
      // available = all - selected
      availableColumns = _.differenceBy(additionalColumnList, selectedColumns, "id");
  
      initialSelectedColumns = [...selectedColumns];
      initialAvailableColumns = [...availableColumns];
    } else {
      selectedColumns = additionalColumnList.filter((el: any) => el.checked);
      availableColumns = additionalColumnList.filter((el: any) => !el.checked);
      initialSelectedColumns = [...selectedColumns];
      initialAvailableColumns = [...availableColumns];
    }
  
    setSelectedColumns(selectedColumns);
    setAvailableColumns(availableColumns);
    setInitialSelectedColumns(initialSelectedColumns);
    setInitialAvailableColumns(initialAvailableColumns);
  };
  

  const itemTemplate = (item: any) => {
    //condition check done
    return <div> {item?.name}</div>;
  };
  const onChange = (event: any) => {
    setAvailableColumns(event.source);
    setSelectedColumns(event.target);
  };

  const saveChanges = async () => {
    const params = getColumnListParams();
    const respResult: any = await statusBoardService.updateColumnsList(params);
    if (respResult.isSuccess) {
      props.updateTableData(true);
      const socketParams: any = {
        socketType: CONSTANTS.SOCKET_TYPE.CUSTOM_COLUMNS,
        updatedUniqueId: statusBoardSocketService.uniqueID,
      };
      statusBoardSocketService.sendSbSocketParams(socketParams);
      Toast.success(t("statusBoardColumnUpdatedSuccess"));
    } else {
      Toast.error(respResult?.message);
    }
  };

  const closeModal = (status: boolean) => {
    props.updateTableData(status);
  };

  const updateTableData = () => {
    setNewColumnPopup(false);
    getAllColumns();
  };

  const getColumnListParams = () => {
    let addedList: any = [];
    let removedList: any = [];
    const addedListIDs: any = [];
    const removedListIDs: any = [];
    const selectedColOrderIDs: any = [];
    addedList = _.differenceBy(initialAvailableColumns, availableColumns, "id");
    removedList = _.differenceBy(initialSelectedColumns, selectedColumns, "id");

    addedList.forEach((element: any) => {
      addedListIDs.push(element.id);
    });
    removedList.forEach((element: any) => {
      removedListIDs.push(element.id);
    });

    selectedColumns.forEach((element: any) => {
      selectedColOrderIDs.push(element.id);
    });

    return {
      statusBoardId: props.statusBoardData.StatusBoardId,
      addedStatusBoardColumn: addedListIDs,
      removedStatusBoardColumn: removedListIDs,
      selectedColOrderIDs: selectedColOrderIDs,
      reg_code: utilService.getNetwork(),
    };
  };

  const newCustomColumn = () => {
    setNewColumnPopup(true);
  };

  return (
    <IonModal
      isOpen={props.showModal}
      backdropDismiss={false}
      className="add-column-model"
    >
      <div className="add-column-cont">
        <div className="pick-list-container">
          <PickList
            source={availableColumns}
            target={selectedColumns}
            itemTemplate={itemTemplate}
            showSourceControls={false}
             sourceHeader={t("availableColumns")}
             targetHeader={t("selectedColumns")}
            sourceStyle={{ height: "390px" }}
            targetStyle={{ height: "390px" }}
            onChange={onChange}
          ></PickList>
        </div>
        <div className="add-column-btn-cont mt-2">
          <IonButton
            className="button secondary-btn btn-curved mr-2"
            color="medium"
            onClick={() => closeModal(false)}
          >
            {t("cancel")}
          </IonButton>
          <IonButton
            className="button primary-btn btn-curved"
            onClick={saveChanges}
          >
            {t("update")}
          </IonButton>
        </div>
        <div className="new-column-btn-cont mt-5">
          <IonButton
            className="button primary-btn rounded-btn"
            onClick={newCustomColumn}
          >
            {t("newCustomColumn")}
          </IonButton>
          {showNewColumnPopup && rolePermissionData.newCustomColumn && (
            <EditCustomColumn
              showModal={showNewColumnPopup}
              statusBoardData={props.statusBoardData}
              updateTableData={updateTableData}
            ></EditCustomColumn>
          )}
        </div>
      </div>
    </IonModal>
  );
};

export default CustomColumn;
